import type { ReactNode } from 'react';
import type React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import Styles from './TableRow.module.scss';

type Props = DeepReadonly<{
  children: ReactNode;
}>;

export const TableRow: React.FC<Props> = ({ children }: Props) => (
  <tr className={Styles.TableRow}>{children}</tr>
);
